import Vue from 'vue'
//自定义指令
Vue.directive('shiro', {//禁用
	bind: function (el, binding, vnode) {
		vnode.elm.disabled=true
		el.style.cursor='not-allowed';
		for(var i=0;i<binding.value.length;i++){
			if(vnode.elm.id==binding.value[i].PERTB001CA00){
				vnode.elm.disabled=false
				el.style.cursor='pointer';
			}
		}
    }
});
Vue.directive('shiroHiden', {//隐藏
	bind: function (el, binding, vnode) {
		el.style.display='none'
		for(var i=0;i<binding.value.length;i++){
			if(vnode.elm.id==binding.value[i].PERTB001CA00){
				el.style.display='inline-block'
			}
		}
    }
});